import { Chip } from "@mui/material";
import { riskLevel, scheduleStatus } from "../constants/labels";

export const OssStatusChip = ({ type = "schedule", value, size = "small" }) => {
  const source = type === "risk" ? riskLevel : scheduleStatus;
  const meta = source[value] || { label: value || "-", tone: "#64748b", bg: "#f8fafc" };
  return (
    <Chip
      size={size}
      label={meta.label}
      variant="outlined"
      sx={{
        height: size === "small" ? 24 : 30,
        borderRadius: "999px",
        borderColor: `${meta.tone}55`,
        bgcolor: meta.bg,
        color: meta.tone,
        fontWeight: 800,
        letterSpacing: 0,
        "& .MuiChip-label": {
          px: size === "small" ? 1 : 1.25,
        },
      }}
    />
  );
};
